export default __webpack_public_path__ + "static/media/login_page_image.62b0f422.jpg";